import { Component } from '@angular/core';

@Component({
  selector: 'app-guest-layout',
  imports: [],
  templateUrl: './guest-layout.html',
  styleUrl: './guest-layout.css',
})
export class GuestLayout {}
